import {createSvgIcon} from '../create-svg-icon';

export const FormatItalicIcon = createSvgIcon(
  <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z" />
, 'FormatItalicOutlined');
